import gql from 'graphql-tag'

import { AggregateRatingsFieldsFragment } from 'main/gql/aggregateRatings'
import { GatheringFieldsFragment } from 'main/gql/gathering'
import { ExtendedProfileFieldsFragment } from 'main/gql/profile'
import { RegistrationFieldsFragment } from 'main/gql/registration'
import { SchoolFieldsFragment } from 'main/gql/school'
import { SchoolReviewFieldsFragment } from 'main/gql/schoolReview'
import { TestimonialFieldsFragment } from 'main/gql/schoolTestimonial'
import { AchievementsFieldsFragment, UserFieldsFragment } from 'main/gql/user'

export const SCHOOL_PAGE_QUERY = gql`
  query SchoolPage($schoolId: Int!) {
    school(id: $schoolId) {
      ...SchoolFields
      useFuzzyAddress
      externalSchoolLicenseNumber
      licenseNumber
      licenseStatus
      readyToMarketAt
      hasFundingAccount
      insertedAt
      hasAvailability
      wonderschoolManagedPhone
      wonderschoolManagedPhoneVisible
      handbookPath
      networks {
        id
        whitelabelOptions
      }
      tuitionBillingPolicy {
        weeklyBillingAccepted
      }
      aggregateRatings {
        ...AggregateRatingsFields
      }
      director {
        ...UserFields
        achievements {
          ...AchievementsFields
        }
      }
      handbook {
        id
        hideFromProfile
      }
      profile {
        ...ExtendedProfileFields
        content
        externalLicenseUrl
      }
      reviews {
        ...SchoolReviewFields
      }
      testimonial {
        ...TestimonialFields
      }
      upcomingGatherings {
        ...GatheringFields
        myRegistration {
          ...RegistrationFields
        }
      }
      featureFlags {
        id
        enabled
      }
    }
    user {
      ...UserFields
    }
    availabilitySurvey: getMostRecentSurvey(schoolId: $schoolId) {
      id
      isOpen
      isStale
      aggregatedAgeRangeMax
      aggregatedAgeRangeMin
      aggregatedOpenSpotsCount
      lastUpdatedOn
    }
  }

  ${AchievementsFieldsFragment}
  ${AggregateRatingsFieldsFragment}
  ${ExtendedProfileFieldsFragment}
  ${GatheringFieldsFragment}
  ${RegistrationFieldsFragment}
  ${SchoolFieldsFragment}
  ${SchoolReviewFieldsFragment}
  ${TestimonialFieldsFragment}
  ${UserFieldsFragment}
`
